function waitForElm(selector) {
    return new Promise(resolve => {
        if (!!document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (!!document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function waitForAngularElement(selector){
    return new Promise(resolve => {
        if(!!angular.element(selector).scope()){
            return resolve(angular.element(selector).scope());
        }

        const observer = new MutationObserver(mutations => {
            if(!!angular.element(selector).scope()) {
               resolve(angular.element(selector).scope());
                observer.disconnect();
            }
        });

        if(!!angular.element(selector).scope()){
            observer.observe(angular.element(selector)[0].ownerDocument.body, {
                childList: true,
                subtree: true,
                attributes: true
            });
        }
    });

    

}
